import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

interface SidebarProps {
  onGenerateReport: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onGenerateReport }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isDashboardActive = location.pathname === '/admin-dashboard';
  const isManageUsersActive = location.pathname.includes('/manage-users');
  const isManageReportActive = location.pathname.includes('/manage-report');

  const handleAdminHome = () => {
    navigate("/admin-dashboard");
  };

  const handleManageUsers = () => {
    navigate("/admin-dashboard/manage-users");
  };

  const handleGenerateReport = () => {
    navigate("/admin-dashboard/manage-report");
    onGenerateReport();
  };

  return (
    <aside className="fixed inset-y-0 left-0 z-40 hidden lg:block w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 overflow-y-auto">
      <div className="p-6">
        <h2 className="text-lg font-semibold mb-6 text-gray-900 dark:text-white">Dashboard Menu</h2>
        <nav className="space-y-1"> {/* Reduced space for tighter layout */}
          <button
            onClick={handleAdminHome}
            className={`w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
              isDashboardActive
                ? "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 shadow-sm"
                : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            }`}
          >
            <svg className="h-5 w-5 mr-3 text-gray-400 dark:text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V7m-1 0V5a2 2 0 00-2-2H6a2 2 0 00-2 2v2m0 0V9a2 2 0 012-2h8a2 2 0 012 2v2m-4 0h4" />
            </svg>
            Dashboard
          </button>
          <button
            onClick={handleManageUsers}
            className={`w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
              isManageUsersActive
                ? "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 shadow-sm"
                : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            }`}
          >
            <svg className="h-5 w-5 mr-3 text-gray-400 dark:text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-5.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
            </svg>
            Manage Users
          </button>
          <button
            onClick={handleGenerateReport}
            className={`w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
              isManageReportActive
                ? "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 shadow-sm"
                : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            }`}
          >
            <svg className="h-5 w-5 mr-3 text-gray-400 dark:text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Generate Report
          </button>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;